module.exports = __webpack_public_path__ + "img/image-1.b0824490.png";